/**
 * Collection card overlay actions.
 * - Wish list: stop propagation so the card image / swiper do not steal the click.
 * - Cart (multi-variant): open quick-buy-modal here — do not stop propagation on cart before
 *   calling show(), and do not rely on body delegate (v1.9 blocked it with stopPropagation on all buttons).
 * - Cart (single variant): stop propagation only; product-form handles submit.
 */
(function () {
  function bindCardActions(root = document) {
    root.querySelectorAll('[data-product-card-actions]').forEach((actions) => {
      if (actions.dataset.actionsBound === 'true') {
        return;
      }

      actions.dataset.actionsBound = 'true';

      actions.querySelectorAll('[data-wish-list-toggle]').forEach((control) => {
        ['click', 'pointerdown'].forEach((type) => {
          control.addEventListener(type, (event) => {
            event.stopPropagation();
          });
        });
      });

      actions.querySelectorAll('.product-card__action-button--cart[aria-controls]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          const modalId = button.getAttribute('aria-controls');
          const modal = modalId ? document.getElementById(modalId) : null;

          if (!modal || typeof modal.show !== 'function') {
            return;
          }

          event.preventDefault();
          void modal.show();
        });
      });

      actions.querySelectorAll('.product-card__quick-form button[type="submit"]').forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();
        });
      });
    });
  }

  function init() {
    bindCardActions();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
